import React, { useEffect } from 'react';
import CollectionList from './collectionList';
import { useRecoilState, useSetRecoilState } from 'recoil';
import EntityList from '../entityForm/entityList';
import ToastMsg from '../toastmsg';
import CollectionService from '../../service/CollectionService';
import LoadingForm from '../modalForm/loadingForm';
import "@fontsource/titillium-web"; 
import genStyles from '../generale.module.css';
import { 
    apiCollectionState, 
    apiPciState, 
    banUriState, 
    collectionsModeleState, 
    collectionsShareState, 
    collectionsState, 
    loadingState, 
    localDataState, 
    openCollectionShareStates, 
    openCollectionStates, 
    reloadCollectionState, 
    repFileState, 
    selectedNameCollectionState, 
    toastState, 
    userDataState
} from '../../atoms/CollectionState';

import { 
    geoJsonMapState,
    openModalCollectionState 
} from '../../atoms/ModalCollectionState';
import ModalCollectionForm from '../modalCollection/modalCollectionForm';
import FullScreenModal from '../modalForm/fullScreenModal';

export default function CollectionForm({ 
    localdata, 
    api_collection, 
    rep_file, 
    api_pci, 
    ban_uri,
    user_data, 
    sharedCollection,
    modeleCollection,
    onParcellesFetched , 
    initGeocoder, 
    fileTypesLinks, 
    mymap,
    containerId,
    featureGroup
}) {
    const setLocalData = useSetRecoilState(localDataState);
    const setApi = useSetRecoilState(apiCollectionState);
    const setRepFile = useSetRecoilState(repFileState);
    const setApiPci = useSetRecoilState(apiPciState);
    const setBanURI = useSetRecoilState(banUriState);    
    const setUser = useSetRecoilState(userDataState);
    const [selected, setSelected] = useRecoilState(selectedNameCollectionState);    
    const setCollections = useSetRecoilState(collectionsState);    
    const setCollectionsShareto = useSetRecoilState(collectionsShareState);    
    const setCollectionsModele = useSetRecoilState(collectionsModeleState);
    const [openStates, setOpenStates] = useRecoilState(openCollectionStates);
    const setOpenShareStates = useSetRecoilState(openCollectionShareStates);      
    const [toast, setToast] = useRecoilState(toastState);     
    const [loading, setLoading] = useRecoilState(loadingState);
    const [reloadCollection, setReloadCollection] = useRecoilState(reloadCollectionState);
    const [openModalcollection, setOpenModalcollection] = useRecoilState(openModalCollectionState);  
    const setGeoJsonMap = useSetRecoilState(geoJsonMapState);

    useEffect(() => {
        //  écouter le signal externe
        const handleReload = (e) => {        
            const paramRecu = e.detail;
            setOpenModalcollection(true);
            setGeoJsonMap(paramRecu);
        };
        
        window.addEventListener("reloadAllListe", handleReload);
      
        return () => window.removeEventListener("reloadAllListe", handleReload);
    }, []);

    useEffect(() => {  

        if(reloadCollection){     
            let api = api_collection+ user_data.account.port+ '/';
            let userId = user_data.user.id;
            getDataCollection(api,userId);
            setReloadCollection(false);
        }
    }, [reloadCollection]);
    

    useEffect(() => {  
        
        setLocalData(localdata);
        const defaultCollection = localdata ? 'Défault' : null;
        setSelected(defaultCollection);
        setApi(api_collection);
        setRepFile(rep_file);
        setApiPci(api_pci);  
        setBanURI(ban_uri);            
        setUser(user_data);
        if (api_collection && user_data) {
            let api = api_collection+ user_data.account.port+ '/';
            let userId = user_data.user.id;
            
            if(!localdata){   
                setLoading(true);       
                getDataCollection(api,userId);
                getDataCollectionShare(api,userId);
                getDataCollectionModele(api);
            }
        }
    }, [api_collection, user_data]);

    const getDataCollection = (api,userId) => {
        CollectionService.fetchCollection(api, userId).then((response) => {            
            const counts = {};
            const formatted = response.map((item) => {
            const name = item.nom_collection;
        
            if (counts[name] === undefined) {
                counts[name] = 0;
            } else {
                counts[name]++;
            }
        
            const suffix = counts[name] === 0 ? '' : ` (${counts[name]})`;
        
            return {
                ...item,
                nom_affiche: `${name}${suffix}`, 
            };
            });
            setCollections(formatted);
            if(reloadCollection){     
                setReloadCollection(false);
            }
            setOpenStates((prev) => {
                const updated = { ...prev };

                formatted.forEach((item) => {
                    if (!(item.id in updated)) {
                    updated[item.id] = false; // ou une autre valeur par défaut
                    }
                });

                return updated;
            });
            setLoading(false);

        });
    };

    const getDataCollectionShare = (api,userId) => {
        CollectionService.fetchCollectionShareto(api, userId).then((response) => {
            const counts = {};
            const formatted = response.map((item) => {
                const name = item.nom_collection;
            
                if (counts[name] === undefined) {
                    counts[name] = 0;
                } else {
                    counts[name]++;
                }
            
                const suffix = counts[name] === 0 ? '' : ` (${counts[name]})`;
            
                return {
                    ...item,
                    nom_affiche: `${name}${suffix}`, 
                };
            });
            setCollectionsShareto(formatted);
            const newOpenStates = {};
            formatted.forEach((item) => {
                newOpenStates[item.id] = false;
            });
            setOpenShareStates(newOpenStates);
            setLoading(false);

        });
    };

    const getDataCollectionModele = (api) => {
        CollectionService.fetchentiteModel(api).then((response) => {            
            setCollectionsModele(response);
        });
    };

    return (
        <div className={genStyles.familyFont}>
            {!selected && 
            <CollectionList 
                onSelect={setSelected} 
                getDataCollectionShare={getDataCollectionShare} 
                sharedCollection={sharedCollection} 
                modeleCollection={modeleCollection} 
            />}
            {selected && 
            <EntityList 
                collectionName={selected} 
                initGeocoder={initGeocoder} 
                fileTypesLinks={fileTypesLinks} 
                mymap={mymap} 
                onParcellesFetched={onParcellesFetched} 
                modeleCollection={modeleCollection} 
                featureGroup={featureGroup}
            />}
            
            {toast && (
                <ToastMsg
                message={toast.message}
                type={toast.type}
                duration={3000}
                onClose={() => setToast(null)}
                />
            )}
            {loading && (
                <LoadingForm containerId={containerId} />
            )}
            {openModalcollection && (
                <FullScreenModal>
                    <ModalCollectionForm onClose={() => setOpenModalcollection(false)} />
                </FullScreenModal>
            )}
        </div>
    );
}
